export function getTextAlignClass(align) {
  var textAlignToClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };
  return textAlignToClass[align] || '';
}
export function getVerticalAlignClass(align) {
  var verticalAlignToClass = {
    top: 'vertical-top',
    middle: 'vertical-middle',
    bottom: 'vertical-bottom'
  };
  return verticalAlignToClass[align] || '';
}